// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BB7xFsri_OIafFcIBN76{color:var(--color-main);font-weight:bold !important}`, "",{"version":3,"sources":["webpack://./src/components/forms/InputWrapper/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,uBAAA,CACA,2BAAA","sourcesContent":[".label\n  color: var(--color-main)\n  font-weight: bold !important\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `BB7xFsri_OIafFcIBN76`
};
export default ___CSS_LOADER_EXPORT___;
